<template>
  <div class="password-meter-group">
    <v-text-field
      ref="input"
      type="password"
      v-model="input"
      @blur="blur"
      :label="label"
      :error-messages="errors"
      :rules="rules"
      :required="required"
      class="mb-0 pb-0"
    />
    <div class="password-meter" v-if="!options.otherPassword">
      <div class="password-meter-inner" :data-score="(info && info.score) || -1"></div>
    </div>
  </div>
</template>

<script>
import * as zxcvbn from 'zxcvbn'

export default {
  props: {
    value: String,
    label: String,
    required: Boolean,
    options: Object,
    field: String,
    model: Object,
    filter: Boolean,
    minLevel: {
      type: Number,
      default: null
    }
  },
  data () {
    let self = this

    return {
      input: this.value,
      errors: [],
      info: null,
      rules: [
        (value) => {
          if (self.options.otherPassword) {
            if (value && value !== self.model[self.options.otherPassword]) {
              return self.$t('user.passwordsMustMatch')
            }
          }
          return true
        },
        (value) => {
          if (value) {
            let info = zxcvbn(value)

            // Load minimum complexity for logged user
            let minimum = self.minLevel !== null
                  ? self.minLevel
                  : ((self.$store.auth.user && self.$store.auth.user.passwordComplexity) || 2)

            // Updated minimum level using values in company form
            if (self.model.passwordComplexity) {
              minimum = self.model.passwordComplexity
            }

            // Save the info to display
            self.updateMeter(info)

            if (info.score < minimum) {
              return self.$t('user.passwordIsTooWeak')
            }
          } else {
            self.updateMeter({ score: -1 })
          }
          return true
        }
      ]
    }
  },
  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    }
  },
  methods: {
    blur () {
      this.$emit('blur')
    },
    focus () {
      this.$refs.input.focus()
    },
    updateMeter (info) {
      this.info = info
    },
    isValid () {
      return !this.rules.find(rule => {
        return rule(this.input) !== true
      })
    }
  }
}
</script>

<style>
.password-meter-group {
  padding: 0px 0px 11px 0px;
}

.password-meter {
  position: relative;
  height: 3px;
  background: #DDD;
  margin-top: 10px;
  border-radius: 3px;
  max-width: 400px;
}

.password-meter:before, .password-meter:after {
  content: '';
  height: inherit;
  background: transparent;
  display: block;
  border-color: #FFF;
  border-style: solid;
  border-width: 0 5px 0 5px;
  position: absolute;
  width: 20%;
  z-index: 10;
}

.password-meter:before {
  left: 20%;
}

.password-meter:after {
  right: 20%;
}

.password-meter-inner {
  background: transparent;
  height: inherit;
  position: absolute;
  width: 0;
  border-radius: inherit;
  transition: width 0.5s ease-in-out, background 0.25s;
}

.password-meter-inner[data-score='-1'] {
  background: darkred;
  width: 0%;
}

.password-meter-inner[data-score='0'] {
  background: darkred;
  width: 20%;
}

.password-meter-inner[data-score='1'] {
  background: orangered;
  width: 40%;
}

.password-meter-inner[data-score='2'] {
  background: orange;
  width: 60%;
}

.password-meter-inner[data-score='3'] {
  background: yellowgreen;
  width: 80%;
}

.password-meter-inner[data-score='4'] {
  background: green;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// PasswordInput.vue?b75a43d6